import React from 'react';

import { useTrackPage } from '@ion/api';
import { MrAppLayout, MrAppMain } from '@ion/components';

import RedirectFeatureGate from 'app/launch-darkly/gates/redirect-feature-gate';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import SideNav from 'app/components/side-nav';
import Header from 'app/components/app-header';

import { BulkDeployPageContextProvider } from './BulkDeployPageContext';
import { BulkDeployModalContextProvider } from './BulkDeployModalContext';
import BulkDeployTable from './BulkDeployTable';
import BulkDeployDiffModal from './modals/BulkDeployDiffModal';
import ConfirmDeployModal from './modals/ConfirmDeployModal';
import DeployProgressModal from './modals/DeployProgressModal';

export default function BulkDeployPage() {
  useTrackPage('bulk_deploy_page_viewed');

  return (
    <RedirectFeatureGate flagName={FEATURE_FLAGS.bulkStageAndDeployRebuild}>
      <MrAppLayout
        title="Pipelines"
        icon="pipelines"
        sideNav={<SideNav />}
        header={<Header icon="pipelines" title="Pipelines" subTitle="Bulk Deploy" />}
      >
        <MrAppMain>
          <BulkDeployPageContextProvider>
            <BulkDeployModalContextProvider>
              <BulkDeployTable />
              <BulkDeployDiffModal />
              <ConfirmDeployModal />
              <DeployProgressModal />
            </BulkDeployModalContextProvider>
          </BulkDeployPageContextProvider>
        </MrAppMain>
      </MrAppLayout>
    </RedirectFeatureGate>
  );
}
